import React, { Fragment, useEffect, useState } from 'react';
import { domains } from '../configs/domains';
import * as MiscService from '../Services/MiscService';
import Chip from './Chip';
import Header from './Heading';
import StatDirection from './StatDirection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faArrowTrendUp, faArrowTrendDown, faCopy } from '@fortawesome/free-solid-svg-icons';
import LoadingComponent from './LoadingComponent';
import ClickCopyComponent from './ClickCopyComponent';

const wrapperStyle = { padding: '10px', margin: '10px' };

const reports = ["Growing Pages", "Declining Pages", "Exact Match Internal links", "One Query multiple Pages"];
export default function GrowingPages({ }) {
    const [active, setActive] = useState('boardandkayak.com');
    const [activeReport, setActiveReport] = useState('Growing Pages');
    const [growingPages, setGrowingPages] = useState(null);
    const [declinigPages, setDeclinigPages] = useState(null);
    const [intelinkingOpportunities, setIntelinkingOpportunities] = useState(null);
    const [exactMatchInternalLinks, setExactMatchInternalLinks] = useState(null);

    const createEditLink = (url) => {
        return <Fragment>
            {url.indexOf("/article/") > -1 && <a href={`/update-article/${url.split("-")[url.split("-").length - 1]}`} target="_blank" style={{ paddingLeft: '10px' }}><FontAwesomeIcon icon={faPen} className="text-sky-500" /></a>}
            {url.indexOf("/products/") > -1 && <a href={`/update-product?url=${url}`} target="_blank" style={{ paddingLeft: '10px' }}><FontAwesomeIcon icon={faPen} className="text-sky-500" /></a>}
        </Fragment>
    }

    useEffect(() => {
        MiscService.getMisc("DASHBOARD", "GROWING_IMPRESSIONS").then(res => {
            setGrowingPages(res.dashboard);
        });
        MiscService.getMisc("DASHBOARD", "DECLINING_IMPRESSIONS").then(res => {
            setDeclinigPages(res.dashboard);
        });
        MiscService.getMisc("DASHBOARD", "INTERLINK_OPPORTUNITIES").then(res => {
            setIntelinkingOpportunities(res.dashboard);
        });
        MiscService.getMisc("DASHBOARD", "INTERLINK_EXACT_MATCH_OPPS").then(res => {
            setExactMatchInternalLinks(res.dashboard);
        });
    }, []);

    const renderTable = (pages) => {
        if (!pages) return <LoadingComponent />
        const domainPages = pages.find(page => {
            return page.domain === active
        });
        return domainPages && domainPages.data ?
            <table className="min-w-full border mt-3">
                <thead className="border-b">
                    <tr>
                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Url</th>
                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Impressions</th>
                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Clicks</th>
                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Position</th>
                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>CTR</th>
                    </tr></thead><tbody>
                    {domainPages.data.map(page => <tr className="border-b" key={page.today.page}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {page.today.page}
                            <ClickCopyComponent text={page.today.page}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                            {createEditLink(page.today.page)}
                        </td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{page.today.impressions} <StatDirection value1={page.today.impressions} value2={page.yesterday.impressions} /></td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{page.today.clicks} <StatDirection value1={page.today.clicks} value2={page.yesterday.clicks} /></td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{Math.floor(page.today.position)}</td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{Math.floor(page.today.ctr * 100)} </td>
                    </tr>)}</tbody></table>
            :
            <p>No Data Available</p>;

    }
    const renderInterlinkingOpportunities = (data) => {
        if (!data) return <LoadingComponent />

        const domainKws = data.find(k => {
            return k.domain === active
        });
        if (!domainKws) return <LoadingComponent />

        return domainKws && domainKws.data && <table className="min-w-full border mt-3">
            <thead className="border-b">
                <tr>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>#</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Keyword</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>pages</th>
                </tr>
            </thead>
            <tbody>
                {domainKws.data.sort((a, b) => b.pages.length - a.pages.length).map((kw, index) =>
                    <tr className="border-b" key={kw.keyword}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{index + 1}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {kw.keyword}
                            <ClickCopyComponent text={kw.keyword}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>

                        </td>
                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Url</th>
                                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Position</th>
                                        <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Impressions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {kw.pages.sort((a, b) => a.position - b.position).map(page =>
                                        <tr>
                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{page.page}
                                                <ClickCopyComponent text={page.page}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                                                {createEditLink(page.page)}</td>
                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{Math.floor(page.position)}</td>

                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{page.impressions}</td>
                                        </tr>)}
                                </tbody>

                            </table>
                        </td>
                    </tr>)}

            </tbody>
        </table >
    }
    const renderExactMatchInternalLinks = (data) => {
        if (!data) return <LoadingComponent />
        const domainKws = data[active]
        if (!domainKws) return <LoadingComponent />


        return domainKws && <table className="min-w-full border mt-3">
            <thead className="border-b">
                <tr className="border-b">
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>#</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Keyword</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Details</th>
                </tr>
            </thead>
            <tbody>{domainKws.map((kw, index) =>
                <tr className="border-b" key={kw.keyword}>
                    <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{index + 1}</td>
                    <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">
                        {kw.keyword}
                        <ClickCopyComponent text={kw.keyword}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                    </td>
                    <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">

                        <Header text="Pages Where Keyword in text" type="h4" />

                        {kw.query_pages.map(page =>
                            <Fragment>
                                {page[0]}
                                <ClickCopyComponent text={page[0]}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                                {createEditLink(page[0])}
                                <br />
                            </Fragment>
                        )}
                        <hr style={{ marginTop: '20px' }} />

                        <Header text="Pages where keywords rank in google" type="h4" />
                        <table>
                            <thead>
                                <tr>
                                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Url</th>
                                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Position</th>
                                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Impressions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {kw.ranking_pages.map(page =>
                                    <Fragment>
                                        <tr>
                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{page.page}
                                                <ClickCopyComponent text={page.page}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                                                {createEditLink(page.page)}</td>
                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{Math.floor(page.position)}</td>

                                            <td className="text-sm text-gray-900 font-light px-3 whitespace-nowrap">{page.impressions}</td>
                                        </tr>

                                        {/* {page.page}
                                <ClickCopyComponent text={page.page}><FontAwesomeIcon icon={faCopy} className="cursor-pointer mx-1 text-sky-500" /></ClickCopyComponent>
                                {createEditLink(page.page)}
                                <br /> */}

                                    </Fragment>
                                )}
                            </tbody>

                        </table>

                    </td>

                </tr>)
            }</tbody></table >
    }


    return (<div style={wrapperStyle}>
        <div style={{ padding: "15px" }}>
            <Header text="Pages" type="h2" />
            <div
                className="flex flex-wrap justify-center space-x-2">
                {[...domains, {
                    key: 'themedspa.store',
                    label: 'themedspa.store',
                    value: 'themedspa.store'
                }].filter(domain => domain.label !== "local").map(domain =>
                    <Chip key={domain.label} color={active == domain.label ?
                        "bg-green-600 text-slate-50 cursor-not-allowed"
                        : "bg-green-400 text-slate-50 hover:bg-green-600 cursor-pointer"} label={domain.label}
                        onClick={() => {
                            setActive(domain.label);
                        }} />)}
            </div>
            <div
                className="flex flex-wrap justify-center space-x-2">
                {reports.filter(report => report !== "local").map(report =>
                    <Chip key={report} color={activeReport == report ?
                        "bg-blue-600 text-slate-50 cursor-not-allowed"
                        : "bg-blue-400 text-slate-50 hover:bg-blue-600 cursor-pointer"} label={report}
                        onClick={() => {
                            setActiveReport(report);
                        }} />)}
            </div>
            {activeReport === "Growing Pages" && <div className="mt-4">
                <Header text={<span>Growing Pages <FontAwesomeIcon icon={faArrowTrendUp} /></span>} type="h3" />
                {renderTable(growingPages)}

            </div>}
            {activeReport === "Declining Pages" && <div className="mt-4">
                <Header text={<span>Declining Pages <FontAwesomeIcon icon={faArrowTrendDown} /></span>} type="h3" />
                {renderTable(declinigPages)}
            </div>}


            {activeReport === "Exact Match Internal links" && <div className="mt-4">
                <Header text={<span>Exact Match Internal Links</span>} type="h3" />
                {renderExactMatchInternalLinks(exactMatchInternalLinks)}
            </div>}

            {activeReport === "One Query multiple Pages" && <div className="mt-4">
                <Header text={<span>Interlinking Opportunities</span>} type="h3" />
                {renderInterlinkingOpportunities(intelinkingOpportunities)}
            </div>}


        </div>
    </div >)
}